import { call, put, select } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import ProfilesActions, { ProfilesTypes } from '../ducks/profiles';
import { profilesAPI } from '../../services/apiRest';

export function* getProfiles() {
  try {
    const profiles = yield call(profilesAPI.listar);
    yield put(ProfilesActions.getProfilesSuccess(profiles));
  } catch (err) {
    yield put(ProfilesActions.getProfilesFailure(err));
    toastr.error('Erro', 'Erro ao buscar perfis');
  }
}

export function* getProfile({ id }) {
  try {
    const profile = yield call(profilesAPI.buscarPorId, id);
    yield put(ProfilesActions.getProfileSuccess(profile));
  } catch (err) {
    yield put(ProfilesActions.getProfileFailure(err));
    toastr.error('Erro', 'Erro ao buscar perfil');
  }
}

export function* addProfile({ profile, closeModal }) {
  try {
    const newProfile = yield call(profilesAPI.criar, profile);
    yield put(ProfilesActions.addProfileSuccess(newProfile));
    toastr.success('Sucesso', 'Perfil criado com sucesso');
    if (closeModal) closeModal();
  } catch (err) {
    yield put(ProfilesActions.addProfileFailure(err));
    toastr.error('Erro', 'Erro ao criar perfil');
  }
}

export function* updateProfile({ id, profile, closeModal }) {
  try {
    console.log('🔄 [profiles saga] Atualizando perfil:', { id, profileNome: profile.nome });
    const updatedProfile = yield call(profilesAPI.atualizar, id, profile);
    console.log('✅ [profiles saga] Perfil atualizado:', { id, nome: updatedProfile.nome });
    yield put(ProfilesActions.updateProfileSuccess(updatedProfile));
    
    // Recarregar permissões do usuário atual se o perfil atualizado for o do usuário logado
    try {
      const state = yield select();
      const userActive = state?.auth?.userActive;
      if (userActive && userActive.profile_id && userActive.profile_id === id) {
        console.log('🔄 [profiles saga] Recarregando permissões do usuário após atualização do perfil');
        yield put(ProfilesActions.getMyPermissionsRequest());
      }
    } catch (error) {
      console.warn('⚠️ [profiles saga] Erro ao verificar perfil do usuário:', error);
      // Não bloquear o fluxo se houver erro ao verificar
    }
    
    toastr.success('Sucesso', 'Perfil atualizado com sucesso');
    if (closeModal) closeModal();
  } catch (err) {
    console.error('❌ [profiles saga] Erro ao atualizar perfil:', err);
    yield put(ProfilesActions.updateProfileFailure(err));
    toastr.error('Erro', 'Erro ao atualizar perfil');
  }
}

export function* removeProfile({ id }) {
  try {
    yield call(profilesAPI.deletar, id);
    yield put(ProfilesActions.removeProfileSuccess());
    toastr.success('Sucesso', 'Perfil removido com sucesso');
  } catch (err) {
    yield put(ProfilesActions.removeProfileFailure(err));
    toastr.error('Erro', 'Erro ao remover perfil');
  }
}

export function* getMyPermissions() {
  try {
    const permissions = yield call(profilesAPI.buscarMinhasPermissoes);
    console.log('✅ [profiles saga] Permissões recebidas:', permissions);
    yield put(ProfilesActions.getMyPermissionsSuccess(permissions));
  } catch (err) {
    yield put(ProfilesActions.getMyPermissionsFailure(err));
    console.error('❌ [profiles saga] Erro ao buscar permissões:', err);
  }
}

